module.exports = __webpack_public_path__ + "img/PSD.50e56cd2.png";